<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      salary_item_degrees: [],
      SalaryItemDegrees: {},
      salaryItems: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchSalaryItemDegrees: null,
      SearchMode: false,
      searchSalary: "",
      // appprices:[]
    };
  },
  methods: {
    addSalaryItemDegrees() {
      var data = {
        title: "popups.addsalaryitemdegree",
        inputs: [
          {
            model: "salary_item_id",
            type: "select",
            label: "popups.salaryitem",
            options: (() => {
              return this.salaryItems.map((salary) => {
                return { value: salary.id, label: salary.name };
              });
            })(),
          },

          {
            model: "degree",
            type: "select",
            label: "popups.degree",
            options: [
              { value: 1, label: 1, checked: true },
              { value: 2, label: 2 },
              { value: 3, label: 3 },
              { value: 4, label: 4 },
              { value: 5, label: 5 },
              { value: 6, label: 6 },
              { value: 7, label: 7 },
              { value: 8, label: 8 },
              { value: 9, label: 9 },
              { value: 10, label: 10 },
              { value: 11, label: 11 },
              { value: 12, label: 12 },
              { value: 13, label: 13 },
              { value: 14, label: 14 },
            ],
          },

          { model: "value", type: "text", label: "popups.value" },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("salary-item-degrees", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    salaryItem(salary) {
      var data = {
        title: "popups.editsalaryitem",
        inputs: [
          {
            model: "salary_item_id",
            type: "select",
            label: "popups.salaryitem",
            options: (() => {
              return this.salaryItems.map((salary) => {
                return { value: salary.id, label: salary.name };
              });
            })(),
          },

          {
            model: "degree",
            type: "select",
            label: "popups.degree",
            options: [
              { value: 1, label: 1, checked: true },
              { value: 2, label: 2 },
              { value: 3, label: 3 },
              { value: 4, label: 4 },
              { value: 5, label: 5 },
              { value: 6, label: 6 },
              { value: 7, label: 7 },
              { value: 8, label: 8 },
              { value: 9, label: 9 },
              { value: 10, label: 10 },
              { value: 11, label: 11 },
              { value: 12, label: 12 },
              { value: 13, label: 13 },
              { value: 14, label: 14 },
            ],
          },

          {
            model: "value",
            type: "text",
            label: "popups.value",
            value: salary.value,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("salary-item-degrees", salary.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.SearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("salary-item-degrees/search", {
          search: this.searchSalary,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          var tempData = [];
          for (var i = 0; i < res.data.length; i++) {
            for (var j = 0; j < res.data[i].salary_item_degrees.length; j++) {
              tempData.push(res.data[i].salary_item_degrees[j]);
            }
          }
          console.log(tempData);
          this.salary_item_degrees = tempData;
        });
    },
    cancelSearchMode() {
      this.searchSalary = "";
      this.SearchMode = false;
      this.get(this.page);
    },
    getSalaryItemDegrees() {
      this.http.get("salary-items").then((res) => {
        this.salaryItems = res.data;
      });
    },
    deleteSalaryItemDegrees(salary) {
      var data = {
        title: "popups.deletesalaryitemdegree",
        msg: "popups.deletemsg",
      };
      this.popup.confirm(data).then((res) => {
        if (res) {
          this.http.delete("salary-item-degrees", salary.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("salary-item-degrees/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.salary_item_degrees = res.data;
          console.log(this.salary_item_degrees);
        });
    },
  },
  created() {
    this.get(1);
    this.getSalaryItemDegrees();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
      :title="$t('salaryItemDegrees.title')"
    />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <div class="search-box chat-search-box" style="width: 250px">
                <div class="position-relative">
                  <input
                    :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
                    @keyup="search()"
                    type="text"
                    class="form-control fa-lg text-light"
                    :placeholder="$t('salaryItemDegrees.search')"
                    v-model="searchSalary"
                    style="background-color: #2a3042 !important"
                  />
                  <i class="bx bx-search-alt search-icon text-light"></i>
                  <button
                    @click="cancelSearchMode()"
                    v-if="SearchMode"
                    class="btn btn-close text-light"
                    style="position: absolute; top: 12px; left: 250px"
                  ></button>
                </div>
              </div>
            </div>
            <div class="col-6" style="display: flex; justify-content: flex-end">
              <button
                type="button"
                @click="addSalaryItemDegrees()"
                class="btn btn-light float-end mb-4"
              >
                <span
                  class="bx bxs-plus-circle float-end fa-2x"
                  style="color: #2a3042 !important"
                ></span>
              </button>
            </div>
          </div>

          <table
            class="table table-striped table-hover mb-0"
            :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
          >
            <thead>
              <tr
                class="text-light text-center"
                style="background-color: #2a3042 !important"
              >
                <th scope="col">{{ $t("salaryItemDegrees.table.id") }}</th>
                <th scope="col">
                  {{ $t("salaryItemDegrees.table.salaryitem") }}
                </th>
                <th scope="col">{{ $t("salaryItemDegrees.table.degree") }}</th>
                <th scope="col">{{ $t("salaryItemDegrees.table.value") }}</th>
                <th scope="col">{{ $t("salaryItemDegrees.table.created") }}</th>
                <th scope="col">{{ $t("salaryItemDegrees.table.updated") }}</th>
                <th scope="col">
                  {{ $t("salaryItemDegrees.table.operations") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(salary, index) in salary_item_degrees"
                :key="salary"
                class="text-center"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ salary?.salary_item?.name }}</td>
                <td>{{ salary.degree }}</td>
                <td>{{ salary.value }}</td>
                <td>{{ salary.created.split("T")[0] }}</td>
                <td>{{ salary.updated.split("T")[0] }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-success me-2 btn-sm"
                    @click="salaryItem(salary)"
                  >
                    {{ $t("popups.edit") }}
                  </button>
                  <a
                    class="btn btn-danger btn-sm me-2"
                    href="javascript:void(0)"
                    role="button"
                    @click="deleteSalaryItemDegrees(salary)"
                    >{{ $t("popups.delete") }}</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <!--   Apps  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
          p
        }}</a>
      </li>

      <li class="page-item" :class="{ disabled: page == total_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->
  </Layout>
</template>
